export default "__VITE_ASSET__BigkZDby__"